import React, { useState, useRef, useEffect } from "react";

const SelectField = ({
  title,
  name,
  value,
  onChange,
  options = [],
  required = false,
  placeholder = "Seleccione una opción",
  disabled = false,
  width = "w-full",
  bgColor = "bg-white",
  border = "border-[#D1D5DB]",
  inModal = false
}) => {

  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleOptionClick = (optionValue, optionLabel) => {
    if (onChange) {
      const event = {
        target: {
          name: name,
          value: optionValue
        }
      };
      onChange(event);
    }
    setIsOpen(false);
  };

  const displayPlaceholder = required && !title && placeholder ? `${placeholder} *` : placeholder;

  const getSelectedLabel = () => {
    if (!value || value === placeholder) return displayPlaceholder;
    const selectedOption = options.find(option => option.value === value);
    return selectedOption ? selectedOption.label : displayPlaceholder;
  };

  return (
    <div className="flex items-center w-full gap-2">
      {title && (
        <p className="font-itcbook text-sm text-[#111928]">
          {title}
          {required && <span className="text-red-500">*</span>}
        </p>
      )}
      <div className={`relative ${width}`} ref={dropdownRef}>
        <button
          type="button"
          className={`border flex items-center ${bgColor} ${width} h-[40px] justify-between ${border} rounded-md font-itcbook text-[14px] pl-3 pr-1 focus:outline-none
            ${disabled ? "bg-gray-100 cursor-not-allowed opacity-50" : ""}`}
          onClick={() => !disabled && setIsOpen(!isOpen)}
          disabled={disabled}
          title={getSelectedLabel()}
        >
          <p className={`font-itcbook text-[14px] overflow-hidden whitespace-nowrap text-ellipsis ${
            value && value !== placeholder ? 'text-black' : 'text-[#6B7280]'
          }`}>
            {getSelectedLabel()}
          </p>

          <div className={`flex items-center justify-center h-full border-l ${border} px-2 ml-3`}>
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.76756 6.63501H13.4401C13.7131 6.63501 13.854 6.96697 13.6624 7.16306C13.6621 7.1634 13.6617 7.16374 13.6614 7.16409L11.2565 9.56896L9.779 11.0465C9.35176 11.4737 8.65585 11.4737 8.22861 11.0465L4.34361 7.16146C4.14767 6.96551 4.28682 6.63501 4.56006 6.63501H8.76756Z" fill="#6B7280" stroke="#6B7280"/>
            </svg>
          </div>
        </button>
        
        {isOpen && (
          <div className={`absolute z-10 mt-1 ${width} bg-white border rounded-md shadow-lg ${border} overflow-y-auto scroll-y-container max-h-[150px]
          ${inModal ? 'relative' : ''}`} 
            style={inModal ? {
              position: 'fixed',
              top: dropdownRef.current ? 
                dropdownRef.current.getBoundingClientRect().bottom  : 'auto',
              left: dropdownRef.current ? 
                dropdownRef.current.getBoundingClientRect().left + window.scrollX : 'auto',
              width: dropdownRef.current ? dropdownRef.current.offsetWidth : '100%',
              zIndex: 9999
            } : {}}
          >
            {options.length > 0 ? (
              options.map((option) => (
                <button
                  key={option.value}
                  onClick={() => handleOptionClick(option.value, option.label)}
                  className="block w-full px-4 py-2 text-[14px] text-left rounded-md font-itcbook hover:bg-[#EFEEF7]"
                >
                  {option.label}
                </button>
              ))
            ) : (
              <div className="px-4 py-2 text-[14px] text-center text-gray-500">
                No hay opciones disponibles
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectField;